import { render, staticRenderFns } from "./ampliacionOtros.vue?vue&type=template&id=11c2f434"
import script from "./ampliacionOtros.vue?vue&type=script&lang=js"
export * from "./ampliacionOtros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports